import { Link } from 'react-router-dom';
import styled from 'styled-components';
import mixins from '@mindtickle/styles';
import { navigationDefaultColors } from '../../data';
import { NAVIGATION_CSS_VARIABLES } from '../../constants';

export const StyledLink = styled(Link)`
  padding: 7px 8px 7px 32px;
  text-decoration: none;
  border-radius: 6px;
  white-space: nowrap;
  color: ${navigationDefaultColors.navRouteNameColor};
  background-color: ${navigationDefaultColors.navRouteBgColor};

  &:hover {
    background-color: ${navigationDefaultColors.navRouteBgHoverColor};
    color: ${navigationDefaultColors.navRouteNameHoverColor};
  }

  &.active-route {
    background-color: var(
      ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_BG_COLOR},
      ${navigationDefaultColors.navRouteBgActiveColor}
    );
    color: ${navigationDefaultColors.navRouteNameActiveColor};
  }

  &.popover-content-link {
    padding: 8px;
  }
`;

export const ELLIPSIS_TOOLTIP_STYLE = { zIndex: mixins.zIndex.TOAST };
